import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider, useStore } from "@/lib/store";
import TitleBar from "@/components/TitleBar";
import Sidebar from "@/components/Sidebar";
import AccountDialog from "@/components/AccountDialog";
import Onboarding from "@/components/Onboarding";
import ReminderWatcher from "@/components/Reminders";
import LiveTV from "@/pages/LiveTV";
import Library from "@/pages/Library";
import Guide from "@/pages/Guide";
import Collection from "@/pages/Collection";

function Shell() {
  const { active } = useStore();
  const [manage, setManage] = useState(false);
  if (!active) return <Onboarding />;
  return (
    <div className="h-screen flex flex-col bg-[#08090E] text-slate-100" data-testid="app-shell">
      <TitleBar onManage={() => setManage(true)} />
      <div className="flex flex-1 min-h-0">
        <Sidebar onManage={() => setManage(true)} />
        <main className="flex-1 min-w-0" key={active.id}>
          <Routes>
            <Route path="/live" element={<LiveTV />} />
            <Route path="/movies" element={<Library kind="movie" />} />
            <Route path="/series" element={<Library kind="series" />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/favorites" element={<Collection mode="favorites" />} />
            <Route path="/recent" element={<Collection mode="recent" />} />
            <Route path="*" element={<Navigate to="/live" replace />} />
          </Routes>
        </main>
      </div>
      <AccountDialog open={manage} onOpenChange={setManage} />
      <ReminderWatcher />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);
  return (
    <StoreProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </StoreProvider>
  );
}
